import Img from "gatsby-image";
import {
  getFixedGatsbyImage,
  getFluidGatsbyImage,
} from "gatsby-storyblok-image";

const OPTIONS = {
  placeholderStyle: { backgroundColor: "transparent" },
};

type ImageProps = {
  fluid?: boolean;
  fixed?: boolean;
  className?: string;
  alt?: string;
  copyright_info?: string;
  data: StoryblokGatsbyImageAsset;
  options?: {
    width?: number;
    height?: number;
    maxWidth?: number;
    maxHeight?: number;
  };
  strategy?: "eager" | "lazy";
};

export function Image({
  fluid,
  fixed,
  data,
  className,
  options = {},
  strategy,
}: ImageProps) {
  const fixedProps =
    fixed && data
      ? getFixedGatsbyImage(data, {
          quality: 80,
          downloadLocal: true,
          ...options,
        })
      : null;

  const fluidProps =
    fluid && data
      ? getFluidGatsbyImage(data, {
          quality: 80,
          smartCrop: false,
          downloadLocal: true,
          ...options,
        })
      : null;

  const imageWithHighPriority = strategy === "eager";

  if (data?.image?.includes(".svg"))
    return <img src={data.image} alt={data._uid} className={className} />;

  const imageCreator = () => {
    if (fixedProps)
      return (
        <Img
          fixed={fixedProps}
          alt={data.alt_tag}
          className={className}
          {...OPTIONS}
        />
      );
    if (fluidProps)
      return (
        <Img
          fluid={fluidProps}
          alt={data.alt_tag}
          className={className}
          {...OPTIONS}
        />
      );

    if (imageWithHighPriority) {
      return (
        <Img
          fluid={fluidProps}
          alt={data.alt_tag}
          className={className}
          loading="eager"
          {...OPTIONS}
        />
      );
    }
    return null;
  };

  return imageCreator();
}
